import { TrackResource } from '@/models'
import { TRACK_FAILURE, TRACK_REQUEST, TRACK_SUCCESS } from '@/redux/actionTypes'

export interface TrackState {
    track: TrackResource | null
    loading: boolean
    errors: unknown[]
}

export type TrackAction =
    | { type: typeof TRACK_REQUEST }
    | { type: typeof TRACK_SUCCESS, track: TrackResource }
    | { type: typeof TRACK_FAILURE, errors: unknown[] }

const initialState: TrackState = {
    track: null,
    loading: false,
    errors: [],
}

export const trackReducer = (state: TrackState = initialState, action: TrackAction): TrackState => {
    switch (action.type) {
        case TRACK_REQUEST:
            return { ...state, loading: true }
        case TRACK_SUCCESS:
            return {
                ...state, loading: false, track: action.track,
            }
        case TRACK_FAILURE:
            return {
                ...state, loading: false, errors: action.errors,
            }
        default:
            return state
    }
}
